/**
 * Shared layout tokens for the teacher portal.
 *
 * The mockup's breakpoints (1024 / 900 / 760 / 600 / 380) do not line up with
 * MUI's stock ones (600 / 900 / 1200 / 1536), so rather than approximate them
 * we express them as raw media queries and use these constants everywhere.
 * `MQ.tablet` is the important one: it is where the mockup swaps the desktop
 * top nav for the bottom nav.
 */
export const MQ = {
  // <= 1024px: bottom navigation, single-column split/attendance grids
  tablet: '@media (max-width:1024px)',
  desktop: '@media (min-width:1025px)',
  // <= 900px: three-up grids collapse to two
  smallTablet: '@media (max-width:900px)',
  // <= 760px: stacked rows, mobile chat, username hidden
  phoneLg: '@media (max-width:760px)',
  // <= 600px: every grid is single column
  phone: '@media (max-width:600px)',
  // <= 380px: tightened type scale
  phoneSm: '@media (max-width:380px)',
};

// `.grid.g2 / .g3 / .g4` — including their collapse points.
export const gridSx = (columns) => {
  const templates = {
    2: {
      display: 'grid',
      gap: '16px',
      gridTemplateColumns: 'repeat(2,1fr)',
      [MQ.phone]: { gridTemplateColumns: '1fr' },
    },
    3: {
      display: 'grid',
      gap: '16px',
      gridTemplateColumns: 'repeat(3,1fr)',
      [MQ.smallTablet]: { gridTemplateColumns: 'repeat(2,1fr)' },
      [MQ.phone]: { gridTemplateColumns: '1fr' },
    },
    4: {
      display: 'grid',
      gap: '16px',
      gridTemplateColumns: 'repeat(4,1fr)',
      [MQ.tablet]: { gridTemplateColumns: 'repeat(2,1fr)' },
      [MQ.phone]: { gridTemplateColumns: '1fr' },
    },
  };
  return templates[columns] || templates[3];
};



// `.section-t`
export const sectionTitleSx = {
  fontSize: '16px',
  fontWeight: 700,
  m: '28px 0 14px',
  color: 'text.primary',
};

// Page content column: `.wrap{max-width:1080px;padding:32px 28px 96px}` with the
// tablet/phone padding steps and room for the fixed bottom nav.
export const wrapSx = {
  maxWidth: 1080,
  mx: 'auto',
  width: '100%',
  padding: '32px 28px 96px',
  [MQ.tablet]: { padding: '26px 20px 108px' },
  [MQ.phoneLg]: { padding: '22px 16px 108px' },
  [MQ.phone]: { padding: '18px 12px 108px' },
};
